/**
 * OrderSummaryStatics
 * --
 */
import { Content, Statistic } from 'components';
import { stringToMoneyFormat } from 'utils';

/**----------------------------------------
 * [Component] 필터
 * ----------------------------------------
 */
const OrderSummaryStatics = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { totalCount, totalPrice, totalDiscount, refundPrice, refundCount } =
    props;

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <Content
        fullWidth
        padding={0}
        backgroundColor={'none'}
        style={{
          marginBottom: 4,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {[
          {
            title: '총 주문건',
            value: stringToMoneyFormat(totalCount ?? 0),
            suffix: '건',
          },
          {
            title: '총 주문금액',
            //NOTE: 전체 결제금액(환불금 포함/할인금 미포함)) + 할인금액
            value: stringToMoneyFormat(
              (totalPrice ?? 0) + Math.abs(totalDiscount) ?? 0
            ),
            suffix: '원',
          },
          {
            title: '실제결제금액',
            //NOFE: 전체 결제금액(환불금 포함/할인금 미포함) - 환불 금액
            value: stringToMoneyFormat(totalPrice - refundPrice ?? 0),
            suffix: '원',
          },
          {
            title: '할인금액',
            value: stringToMoneyFormat(totalDiscount ?? 0),
            suffix: '원',
          },
          {
            title: '환불',
            value: stringToMoneyFormat(refundCount ?? 0),
            suffix: '건',
          },
          {
            title: '환불금액',
            value: stringToMoneyFormat(refundPrice ?? 0),
            suffix: '원',
          },
        ].map((_item, _index) => (
          <div
            key={`${_item.label}-${_index}`}
            className="boxShadow"
            style={{
              background: '#FFFFFF',
              borderRadius: 4,
              width: `90%`,
              // width: `calc(100% / 3)`,
              // marginRight: _index === 7 ? 0 : 4,
              margin: '0 2px',
              padding: '24px 15px',
            }}
          >
            <Statistic
              title={_item.title}
              value={_item.value}
              suffix={_item.suffix}
              direction={'row'}
              style={{ justifyContent: 'center' }}
            />
          </div>
        ))}
      </Content>
    </>
  );
};

export default OrderSummaryStatics;
